module.exports = __webpack_public_path__ + "static/media/presse.1518a66d.jpg";